import { Controller } from "stimulus"

export default class extends Controller {
    static targets = [ "agentSel", "accountType" ]

    connect() {
        const val = this.agentSelTarget.value;
        if (val !== '') {
            this.updateAccountType(val);
        }

        this.agentSelTarget.addEventListener('change', (e)=>{
            const val = e.target.value;
            if (val === '') {
                this.accountTypeTarget.textContent = '';
                return
            }
            this.updateAccountType(val);
        });
    }

    updateAccountType(val) {
        $.ajax({
            url: '/accounts/' + val + '/agent_info',
            type: 'get',
            dataTye: 'text'
        }).done((data)=>{
            this.accountTypeTarget.textContent = data;
        });
    }
}
